<template>
  <NuxtLink
    :to="
      localePath({
        name: 'finishes-slug',
        params: {
          slug: finishing.slug,
        },
      })
    "
    :data-hoverable="$t('cursor.view')"
    @mouseenter="toggleHover"
    @mouseleave="toggleHover"
    :class="{ active: hovered }"
  >
    <div class="page-finishings-list-block__wrap">
      <!-- Ico -->
      <img
        class="page-finishings-list-block__ico"
        src="~/assets/img/ico/ico-arrow-forward-light.svg"
        alt="Ico arrow forward light"
        width="18"
        height="16"
      />
      <!-- Image -->
      <div
        class="page-finishings-list-block__texture"
        :style="{
          '--background-color': finishing.finishingColorCode,
        }"
      >
        <WidgetPicture
          v-if="finishing?.finishingColorTexture?.[0]"
          :image="{
            custom: finishing.finishingColorTexture[0],
          }"
          :lazyLoad="true"
          :alt="finishing.finishingColorTexture[0].url.title"
        />
      </div>
    </div>

    <h3
      class="text-s link-underline-reverse-1 page-finishings-list-block__title"
      :class="{ active: hovered }"
    >
      <span class="text-uppercase">{{ finishing.title }}</span>
      <span
        v-if="
          finishing?.finishingColorLabel?.toLowerCase() !==
          finishing?.title?.toLowerCase()
        "
        >{{ finishing?.finishingColorLabel }}</span
      >
    </h3>
  </NuxtLink>
</template>

<script>
export default {
  name: 'PagesFinishingsListBlock',
}
</script>

<script setup>
const props = defineProps({
  finishing: Object,
})

const hovered = ref(false)
const touch = ref(false)

const toggleHover = () => {
  hovered.value = !hovered.value && touch.value
}

onMounted(() => {
  touch.value = 'ontouchstart' in window || navigator.maxTouchPoints
})
</script>

<style lang="scss">
@import './style.scss';
</style>
